import Admin from "./Components/AdminComponent/admin"
import Home from "./Components/HomeComponent/home"
import Interface from "./Components/UiComponent/ui"
import "./App.css"

import { BrowserRouter, Route } from "react-router-dom"

const routerBasename = window.location.pathname.startsWith("/casa-giu") ? "/casa-giu" : ""

function App() {
     return (
          <BrowserRouter basename={routerBasename}>
               <Route exact path="/" component={Interface} />
               <Route exact path="/admin" component={Admin} />
               <Route exact path="/home" component={Home} />
               <Route exact path="/ui" component={Interface} />
               <Route exact path="/:cameraPage(\\d+)" component={Interface} />
          </BrowserRouter>
     )
}

export default App
